





















































import Vue from 'vue';
import { createNamespacedHelpers, mapState as mapRootState } from 'vuex';
import moment from 'moment';
const { mapState, mapGetters } = createNamespacedHelpers('grievanceItem');
const grievanceFormGetters = createNamespacedHelpers('grievanceForm').mapGetters;
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    computed: {
        ...mapCustomLabelsState(['claimant']),
        ...mapState(['refNo', 'status', 'type', 'parentCategory', 'category', 'date']),
        ...mapGetters(['getFieldLabel', 'getAuthor']),
        ...grievanceFormGetters(['isFieldVisible']),
        ...mapRootState(['locale', 'portalBranding']),
        dateTimeString() {
            moment.locale(this.locale);
            return moment(this.date).format('LLL');
        },
    },
});
